import { FileIcon } from 'lucide-react'
import * as React from 'react'

import { cn } from '../lib/cn'

export interface EmptyProps extends React.HTMLAttributes<HTMLDivElement> {
  description?: React.ReactNode
  icon?: React.ReactNode
}

const Empty = React.forwardRef<HTMLDivElement, EmptyProps>(
  ({ description = 'No Data', icon, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-col items-center justify-center py-10 text-muted-foreground', className)}
      {...props}
    >
      <div className='mb-4'>{icon ?? <FileIcon className='h-10 w-10 text-muted-foreground' />}</div>
      <p className='text-sm'>{description}</p>
    </div>
  ),
)
Empty.displayName = 'Empty'

export { Empty }
